/* eslint-disable @typescript-eslint/naming-convention */
import { ISalonResponse } from '../../IApiResponses';
import { IUserSalon } from '../../../domain/entities/Salon/UserSalon';
import Salon from '../../../domain/entities/Salon/Salon';

const salonMapper = {
  response(salon: ISalonResponse): IUserSalon {
    const {
      salon_id: selectedSalonId,
      stylist_name: stylistName,
      salon_data_share_flag: isPrivacyPolicyAccepted,
      doors,
    } = salon;

    const nearbySalons: Salon[] = [];
    Object.keys(doors).forEach(salonId => {
      const salonFromResponse = doors[salonId];
      const mappedSalon = {
        doorAddress: salonFromResponse.address,
        doorCity: salonFromResponse.city,
        doorName: salonFromResponse.doorname,
        doorState: salonFromResponse.state,
        salonId,
      };
      nearbySalons.push(mappedSalon);
    });

    return {
      isPrivacyPolicyAccepted: isPrivacyPolicyAccepted ?? true,
      nearbySalons,
      selectedSalonId,
      stylistName: stylistName || '',
    };
  },
};

export default salonMapper;
